import { Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { ContentWidthSetting } from './ContentWidthSetting';
import { LanguageSetting } from './LanguageSetting';
import { ThemeSetting } from './ThemeSetting';

interface SettingsDrawerProps {
    open: boolean;
    onClose: () => void;
}

/**
 * Cajón de ajustes de apariencia (tema, ancho del contenido e idioma), igual
 * que en sporttia-competitions. Se abre desde la cabecera del sidebar.
 */
export function SettingsDrawer({
    open,
    onClose,
}: SettingsDrawerProps): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            slotProps={{ paper: { sx: { width: 384, maxWidth: '100vw' } } }}
        >
            <div className="border-border flex items-start justify-between gap-4 border-b p-4">
                <div>
                    <h2 className="m-0 text-base font-semibold">
                        {t('settings.title')}
                    </h2>
                    <p className="text-muted-foreground m-0 text-sm">
                        {t('settings.description')}
                    </p>
                </div>
                <IconButton
                    size="small"
                    onClick={onClose}
                    aria-label={t('general.close')}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>

            <div className="flex flex-col gap-6 overflow-y-auto p-4">
                <ThemeSetting />
                <ContentWidthSetting />
                <LanguageSetting />
            </div>
        </Drawer>
    );
}
